import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Loading, ErrorBox } from "../components/common";
import Certificate from "../components/Certificate";

export default function PrintRecord() {
  const { key, id } = useParams();
  const { meta } = useApp();
  const [rec, setRec] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/m/${key}/records/${id}`).then((r) => setRec(r.data)).catch((e) => setErr(errMsg(e))); }, [key, id]);
  if (err) return <div className="p-8"><ErrorBox text={err} /></div>;
  if (!rec) return <Loading />;
  if (!["issued", "released"].includes(rec.status)) return <div className="p-8"><ErrorBox text="Only issued documents can be printed." /></div>;
  const d = rec.data;
  return <Certificate branding={meta.branding} doc={{ document_type: d.document_type, name: d.resident_name || d.requester_name || "[Restricted]", address: d.address, purpose: d.purpose, issued_at: d.issued_at, document_no: d.document_no, reference: rec.ref_no }} />;
}
